export function updateModuleId(moduleName: string): void | null {
    let modulesData = localStorage.getItem('currentUser');
    if (modulesData) {
        try {
            const modulesJson = JSON.parse(modulesData);
            const modules = modulesJson.modules;
            const targetModule = modules.find((mod: any) => mod.moduleName === moduleName);
            const targetModuleMenu = modulesJson.moduleMenus.find((mod: any) => mod.menuName === moduleName);
            if (targetModuleMenu) {
                sessionStorage.setItem('moduleId', targetModuleMenu.moduleId);
                sessionStorage.setItem('moduleMenuId', targetModuleMenu.moduleMenuId);
                return;
            }
            if (targetModule && moduleName !== 'FuelEU') {
                sessionStorage.setItem('moduleId', targetModule.moduleId);
                return;
            }
          
           
        } catch (error) {
            console.error('Error parsing modulesData from localStorage:', error);
        }
    }
    return null;
}

export const getModuleId = (): string | null => {
    return sessionStorage.getItem('moduleId');
};

export const clearModuleId = (): void => {
    sessionStorage.removeItem('moduleId');
    sessionStorage.removeItem('moduleMenuId');
};

  // Map route paths to module names
export const routeToModuleMap: { [key: string]: string } = {
  '/pages/analytics/dashboard': 'AnalyticsKPI',
  '/pages/analytics/detail': 'AnalyticsKPI',
  '/pages/download': 'Downloads', 
  '/pages/ems/aer': 'AER – CII Rating',
  '/pages/ems/emission': 'Emissions',
  '/pages/ems/eu-mrv': 'EU MRV',
  '/pages/ems/imo-dcs': 'IMO DCS',
  '/pages/ems/poseidon-principles': 'Poseidon Principles',
  '/pages/ems/sea-cargo-charter': 'Sea Cargo Charter',
  '/pages/ems/uk-mrv': 'UK MRV',
  '/pages/ets/emission-accounting': 'Emission accounting',
  '/pages/ets/eua-accounting': 'EUA Accounting',
  '/pages/ets/eua-invoicing': 'EUA Invoicing',
  '/pages/ets/eua-procurement': 'EUA Procurement',
  '/pages/ets/accounting': 'Accounting',
  '/pages/ets/overview': 'Overview',
  '/pages/ets/reports': 'Reports',
  '/pages/ets/voyage-data': 'Voyage Data',
  '/pages/fuel-eu/penalty-calculator-next': 'Penalty Calculator',
  '/pages/fuel-eu/fuel-eu': 'FuelEU',
  '/pages/maptiler': 'TrackingScreen',
  '/pages/passages': 'Exclude',
  '/pages/report/list-report': 'Report',
  '/pages/settings/alertsettings/standard-alerts': 'Standard Alert',
  '/pages/settings/api-settings': 'Position and Weather API',
  '/pages/settings/commerical-rates': 'Commercial Rates',
  '/pages/settings/configuration': 'Configuration',
  '/pages/settings/consumption-categories': 'Consumption Category',
  '/pages/settings/custom-kpi/emission-kpi': 'Emission-Kpi',
  '/pages/settings/custom-kpi/list-fuel-kpi': 'Fuel-Kpi',
  '/pages/settings/custom-kpi/add-fuel': 'Fuel-Kpi',
  '/pages/settings/custom-kpi/list-position-kpi': 'Position-Kpi',
  '/pages/settings/custom-kpi/add': 'Position-Kpi',
  '/pages/settings/customvessel': 'Custom-Vessel',
  '/pages/settings/currency-master': 'Currency Master',
  '/pages/settings/dt-model': 'DT Model',
  '/pages/settings/event': 'Event',
  '/pages/settings/fuel-category': 'Fuel Category',
  '/pages/settings/fuels': 'Fuels',
  '/pages/settings/fuel': 'Fuel',
  '/pages/settings/lube-oil': 'Lube Oil',
  '/pages/settings/nox-pm-factor': 'NOX-PM-Factors',
  '/pages/settings/operator': 'Operator',
  '/pages/settings/port': 'Port',
  '/pages/settings/principals': 'Principals',
  '/pages/settings/sea-shopdata': 'Sea and Shop Trial Data',
  '/pages/settings/units-of-measure-and-threshold': 'Units Of Measure And Threshold',
  '/pages/settings/vessel-class': 'Vessel Class',
  '/pages/settings/vessel-group': 'Vessel Group',
  '/pages/settings/vessels-pooltype': 'Vessel Size',
  '/pages/settings/vessel': 'Vessel',
  '/pages/time-charterer': 'TimeCharterer',
  '/pages/userSetting/role': 'Role',
  '/pages/userSetting/user': 'Users',
  '/pages/verification': 'Data Verification',
  '/pages/terms/passage-term': 'Time Charter Terms',
  '/pages/terms/voyage-term':'Voyage Performance',
  '/pages/terms/pool-term':'Pool Terms',
  '/pages/terms/tc-term':'TC Terms 2.0',
  '/pages/settings/standard-alerts': 'AlertSettings',
  '/pages/settings/sensor-module': ''

};
